/* eslint-disable max-len */
import Phaser from 'phaser';

import Ball from '../entities/Ball';
import Maze from '../entities/Maze';

import ballData from '../data/ballData';
import mazeData from '../data/mazeData';

// import config from '../config';
import pageParams from '../pageParams';

class SiteScene extends Phaser.Scene {
    constructor() {
        super('SiteScene');
    }

    create() {
        this.isChangeTo = '';

        this.createBall();
        this.createMaze();

        // this.reserchPageAnimation();
        // this.designPageAnimation();
        // this.launchPageAnimation();
        this.getPageAnimation(window.location.pathname);
    }

    update() {
        if (this.sys.game.isChangePage && this.isChangeTo === '') {
            this.isChangeTo = this.sys.game.to;
        }
        if (!this.sys.game.isChangePage && this.isChangeTo !== '') {
            this.getPageAnimation(this.isChangeTo);
            this.isChangeTo = '';
        }
    }

    createBall() {
        const { [pageParams.screenSize]: { siteDiameter } } = ballData;
        this.ball = new Ball(this, 0, 0, siteDiameter, 'siteBall');
    }

    createMaze() {
        if (pageParams.screenSize === 'l' || pageParams.screenSize === 'xl') {
            const {
                [pageParams.screenSize]: {
                    x, y, maze, shadowOffset, finishData = null,
                },
            } = mazeData;

            this.maze = new Maze(this, pageParams.offsetLeft + x, pageParams.offsetTop + y, maze, shadowOffset, finishData, this.sys.game.isRenderGame);
        }
    }

    mainPageAnimation() {
        this.ball.setAlpha(0);
        this.maze.mainPageAnimation();
    }

    researchPageAnimation() {
        this.ball.setAlpha(0);
        this.maze.researchPageAnimation(() => this.ball.researchPageAnimation());
    }

    designPageAnimation() {
        this.ball.setAlpha(0);
        this.maze.designPageAnimation(() => this.ball.designPageAnimation());
    }

    launchPageAnimation() {
        this.ball.setAlpha(0);
        this.maze.launchPageAnimation(() => this.ball.launchPageAnimation());
    }

    pageWithoutMaze() {
        this.maze.setAlpha(0);
        this.ball.setAlpha(0);
    }

    getPageAnimation(path) {
        switch (path) {
        case '/':
            this.mainPageAnimation();
            break;
        case '/direction/research':
            this.researchPageAnimation();
            break;
        case '/direction/design':
            this.designPageAnimation();
            break;
        case '/direction/launch':
            this.launchPageAnimation();
            break;
        default:
            this.pageWithoutMaze();
            break;
        }
    }
}

export default SiteScene;
